import { atom } from "jotai";

export const zslFeedbackPredictionIdAtom = atom("");
zslFeedbackPredictionIdAtom.debugLabel = "zslFeedbackPredictionIdAtom";
